module.exports = require('../impls/$split-groups/split-groups.js').__splitGroups;